import {
  OpcClientCreateRequest,
  OpcClientInputs,
  OpcClientUpdateRequest,
} from '../../../types/app/opcClient.types';

export const convertDataFromInputToCreateRequest = (
  data: OpcClientInputs,
): OpcClientCreateRequest => ({
  instanceName: data.instanceName,
  endpointAddress: data.endpointAddress,
  comment: data.comment,
});

export const convertDataFromInputToUpdateRequest = (
  data: OpcClientInputs,
): OpcClientUpdateRequest => ({
  id: data.id!,
  instanceName: data.instanceName,
  endpointAddress: data.endpointAddress,
  comment: data.comment,
});
